import { navLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-accent-900 text-background-200">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center bg-accent-500 text-background-50 rounded-lg text-sm font-bold">60</span>
              <span className="text-lg font-heading text-background-50">6080电影网</span>
            </div>
            <p className="text-xs text-background-400 leading-relaxed">
              最新电影抢先看，高清不缓冲，秒开无广告。每日更新10+部最新大片，4K超清画质，全平台免费在线观看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <a key={link.href} href={link.href} className="text-xs text-background-400 hover:text-background-200 transition-colors">
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-3">热门专题</h4>
            <div className="flex flex-col gap-2">
              <a href="#topics" className="text-xs text-background-400 hover:text-background-200 transition-colors">科幻大片</a>
              <a href="#topics" className="text-xs text-background-400 hover:text-background-200 transition-colors">悬疑推理</a>
              <a href="#topics" className="text-xs text-background-400 hover:text-background-200 transition-colors">动作冒险</a>
              <a href="#index" className="text-xs text-background-400 hover:text-background-200 transition-colors">主题合集</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-3">合作伙伴</h4>
            <p className="text-xs text-background-400 leading-relaxed">
              诚邀优质影视内容方、发行商及品牌合作，共同为影迷提供更丰富的观影选择。
            </p>
            <a href="#contact" className="inline-block mt-2 text-xs text-accent-300 hover:text-accent-200 transition-colors">联系我们 →</a>
          </div>
        </div>

        <div className="border-t border-background-400/20 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 6080电影网. 本站内容仅供学习交流，请支持正版影视作品。
          </p>
          <div className="flex items-center gap-4">
            <a href="#about" className="text-xs text-background-500 hover:text-background-300 transition-colors">关于我们</a>
            <a href="#faq" className="text-xs text-background-500 hover:text-background-300 transition-colors">常见问题</a>
            <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}